export default __webpack_public_path__ + "static/envelope-flower-8804edd3ea4fd0efaaac9737a0437cab.png";